import React from 'react';

/**
 * Skeleton loader atractivo para la página de menú
 * Da la sensación de que las imágenes se están cargando muy rápido
 */
const MenuSkeletonLoader: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#e9ecef] animate-pulse">
      {/* Header Skeleton */}
      <div className="bg-[#22B6B2] px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-white/20 rounded-lg animate-pulse"></div>
          </div>
          <div className="flex-1 mx-4">
            <div className="h-8 bg-white/20 rounded-lg animate-pulse"></div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-16 h-6 bg-white/20 rounded animate-pulse"></div>
            <div className="w-10 h-10 bg-white/20 rounded-full animate-pulse"></div>
          </div>
        </div>
      </div>

      {/* Categories Skeleton */}
      <div className="px-4 py-6">
        <div className="flex space-x-4 overflow-x-auto pb-4">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="flex-shrink-0">
              <div className="w-20 h-20 bg-white rounded-full animate-pulse mb-2"></div>
              <div className="w-16 h-4 bg-white rounded animate-pulse mx-auto"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Menu Items Grid Skeleton */}
      <div className="px-4 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(9)].map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              {/* Image Skeleton with shimmer effect */}
              <div className="relative h-48 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer"></div>
                <div className="absolute top-3 right-3 w-8 h-8 bg-white/80 rounded-full animate-pulse"></div>
              </div>
              
              {/* Content Skeleton */}
              <div className="p-4 space-y-3">
                {/* Title */}
                <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
                
                {/* Description */}
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                </div>
                
                {/* Price and Button */}
                <div className="flex items-center justify-between pt-2">
                  <div className="w-16 h-6 bg-gray-200 rounded animate-pulse"></div>
                  <div className="w-20 h-8 bg-[#22B6B2] rounded-lg animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Floating Cart Skeleton */}
      <div className="fixed bottom-20 right-4 z-40">
        <div className="w-14 h-14 bg-[#22B6B2] rounded-full shadow-lg animate-pulse flex items-center justify-center">
          <div className="w-6 h-6 bg-white/80 rounded animate-pulse"></div>
        </div>
      </div>

      {/* Loading Message */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
        <div className="bg-white/90 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center">
          <div className="relative mb-4">
            <div className="w-16 h-16 border-4 border-[#22B6B2]/20 border-t-[#22B6B2] rounded-full animate-spin mx-auto"></div>
            <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-t-[#2C4358] rounded-full animate-spin mx-auto" style={{ animationDelay: '0.5s' }}></div>
          </div>
          <h3 className="text-lg font-bold text-[#2C4358] mb-2">Cargando menú...</h3>
          <p className="text-[#85929e] text-sm">Preparando los mejores platos para ti</p>
          
          {/* Animated dots */}
          <div className="flex justify-center mt-3 space-x-1">
            {[...Array(3)].map((_, index) => (
              <div
                key={index}
                className="w-2 h-2 bg-[#22B6B2] rounded-full animate-bounce"
                style={{ animationDelay: `${index * 0.1}s` }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuSkeletonLoader; 